// Consume bearer material before importing any application or third-party code.
if (window.location.pathname.replace(/\/$/, '') === '/liveness') {
  const referrer = document.createElement('meta')
  referrer.name = 'referrer'
  referrer.content = 'no-referrer'
  document.head.appendChild(referrer)
  let generation = 0
  const openPortal = () => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get('token') || ''
    window.history.replaceState(null, '', window.location.pathname)
    const current = ++generation
    import('./liveness-entry').then(({ mountPortal }) => {
      if (current === generation) mountPortal(token)
    }).catch(() => {
      if (current === generation) document.getElementById('root').textContent = 'We couldn’t open the selfie page. Check your internet connection, then get a new link from OnlyFlexer.'
    })
  }
  openPortal()
  window.addEventListener('hashchange', () => {
    if (window.location.pathname.replace(/\/$/, '') === '/liveness' && window.location.hash) openPortal()
  })
} else {
  import('./app-root')
}
